module.exports = "<div *ngIf='available' class=\"d-block d-sm-none\">\n  <button pageScroll href=\"#summarySection\" [innerText]='messages[\"summary.previewCta\"]'\n          data-slnm-ihg=\"ctaPreviewChangesSID\"\n          class=\"cta-button hThree themeBG w-100 text-center\"></button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/preview-summary-button/preview-summary-button.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/preview-summary-button/preview-summary-button.component.html
// module chunks = 0